
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/ometria",
      function () {
        return require("private-next-pages/destinations/ometria.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/ometria"])
      });
    }
  